import { isValidNewPassword, PASSWORD_MIN_LENGTH, PASSWORD_TOO_SHORT_MESSAGE } from '@naia-app/shared';

export { PASSWORD_MIN_LENGTH, PASSWORD_TOO_SHORT_MESSAGE };

export interface PasswordRule {
  key: string;
  label: string;
  ok: boolean;
}

export function passwordRules(pw: string): PasswordRule[] {
  return [{ key: 'len', label: `Au moins ${PASSWORD_MIN_LENGTH} caractères`, ok: isValidNewPassword(pw) }];
}

export function isStrongPassword(pw: string): boolean {
  return isValidNewPassword(pw);
}
